module.exports = {"371622001":"信城街道","371622002":"金阳街道","371622101":"商店镇","371622102":"温店镇","371622103":"河流镇","371622104":"翟王镇","371622105":"流坡坞镇","371622106":"水落坡镇","371622107":"劳店镇","371622204":"洋湖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371622.json
// module id = 1496
// module chunks = 0